import React from 'react';
import './Pagination.css';

const Pagination = ({ fromPos, maxResults, onPrevious, onNext, hasResults, disableGoNext = false }) => {
  const currentPage = Math.floor(fromPos / maxResults) + 1;
  const canGoPrevious = fromPos > 0;
  const canGoNext = !disableGoNext && hasResults && hasResults >= maxResults;

  return (
    <div className="pagination-container">
      <button 
        className="pagination-btn" 
        onClick={onPrevious} 
        disabled={!canGoPrevious}
      >
        ← Vorherige
      </button>
      <span className="pagination-info">
        Seite {currentPage}
      </span>
      <button 
        className="pagination-btn" 
        onClick={onNext} 
        disabled={!canGoNext}
      >
        Nächste →
      </button>
    </div>
  );
};

export default Pagination;